/* =================== MODAL =================== */

// Abre o modal
function openModal(modal) {
  $("body").addClass("modal-open");
  $("#" + modal).addClass("open");
  $("#" + modal).trigger("modal-open");
}

// Fecha o modal
function closeModal(modal) {
  $("body").removeClass("modal-open");
  $("#" + modal).removeClass("open");
  $("#" + modal).trigger("modal-close");
}

// Abre o modal de alerta
function showAlert(titulo, mensagem, tipo) {
  $("#modal-alert").removeClass("success warning error");
  $("#modal-alert").addClass(tipo);
  $("#alert-titulo").text(titulo);
  $("#alert-texto").html(mensagem);
  openModal("modal-alert");
}

$(function () {
  // Abre o modal ao clicar no botão
  $(".modal-open").on("click", function (e) {
    e.preventDefault();
    openModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar no botão
  $(".modal-close").on("click", function (e) {
    e.preventDefault();
    closeModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar em qualquer outro lugar da tela
  $(".modal").on("click", function (e) {
    if (e.target == this && !$(this).hasClass("modal-force")) {
      closeModal($(this).attr("id"));
    }
  });

  // Fecha o modal ao pressionar a tecla ESC
  $(document).on("keyup", function (e) {
    if (e.keyCode == 27) {
      $(".modal.open")
        .not(".modal-force")
        .each(function () {
          closeModal($(this).attr("id"));
        });
    }
  });

  // Abre o modal de vídeo (Youtube ou Vimeo)
$(".modal-video-open").on("click", function (e) {
  e.preventDefault();
  var $el = $(this);
  
  // Pegamos o código, o título e também o tipo (youtube ou vimeo)
  openModalVideo($el.data("video-cod"), $el.data("video-tit"), $el.data("video-tipo"));
});

function openModalVideo(videoCod) {
  var videoTit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var videoTipo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "youtube"; // Padrão é youtube se não definido
  var $modalVideo = $("#modal-video");
  
  if ($modalVideo.length) {
    var videoSrc = "";

    // Verifica o tipo de vídeo e monta a URL certa
    if (videoTipo === "vimeo") {
      videoSrc = "https://player.vimeo.com/video/".concat(videoCod, "?autoplay=1");
    } else {
      // Padrão: YouTube
      videoSrc = "https://www.youtube.com/embed/".concat(videoCod, "?autoplay=1&rel=0&showinfo=0");
    }

    // Monta o iframe com a URL dinâmica
    var iframe = "\n      <iframe \n        src=\"".concat(videoSrc, "\" \n        frameborder=\"0\" \n        allow=\"autoplay; encrypted-media\" \n        allowfullscreen>\n      </iframe>");
    
    $modalVideo.find(".bloco-video-wrapper").html(iframe);
    
    if (videoTit != "") {
      $modalVideo.find(".bloco-video-titulo").html(videoTit);
    }
    
    openModal("modal-video");
  }
}


  // Fecha o modal de vídeo (Youtube)
  $("#modal-video").on("modal-close", function () {
    $("#modal-video").find(".bloco-video-wrapper").html("");
    $("#modal-video").find(".bloco-video-titulo").html("");
  });
});
